import * as React from "react"

export default function MenuIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.5 3.333h15V5h-15V3.333zm0 5.834h15v1.666h-15V9.167zM2.5 15h15v1.667h-15V15z"
        fill={props.fill}
      />
    </svg>
  )
}
